<template>
  <div class="service__card" v-if="card && title" width="300">
    <div class="service__card__inner">
      <div class="service__card__category" v-if="categories">
        <div class="service__card__actions">
          <button class="service__card__edit" @click="editNote(card.id)">
            Edit
          </button>
          <button class="service__card__edit" @click="showNote(card.id)">
            Show
          </button>
          <button class="service__card__edit" @click="toggle()">
            {{ label }}
          </button>
        </div>
        <h6>
          {{ category }}
        </h6>
      </div>
      <div class="service__card__title">
        <h4 :style="{ backgroundColor: getColor(categories) }">{{ title }}</h4>
      </div>
      <div
        class="service__card__description"
        v-html="what"
        v-if="computedOpen"
      ></div>
      <div
        class="service__card__description"
        v-html="difference"
        v-if="computedOpen"
      ></div>
      <div
        class="service__card__description"
        v-html="learn"
        v-if="computedOpen"
      ></div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "FourCornersCard",
  data() {
    return {
      open: false,
    };
  },
  props: {
    card: Object,
    all: Array,
    isOpen: {
      type: Boolean,
      default: false,
    },
    category: {
      type: String,
      default: "",
    },
  },
  computed: {
    title() {
      return this.item ? this.item.title : null;
    },
    what() {
      return this.item ? this.item.what : null;
    },
    difference() {
      return this.item ? this.item.difference : null;
    },
    learn() {
      return this.item ? this.item.learn : null;
    },
    item() {
      return this.all.find((x) => x.id == this.card.id);
    },
    computedOpen() {
      return this.isOpen || this.open ? true : false;
    },
    exapndable() {
      return this.what || this.learn || this.difference ? true : false;
    },
    label() {
      return this.open ? "Close" : "Expand";
    },
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
    editNote(id) {
      this.$emit("editNote", id);
    },
    showNote(id) {
      this.$emit("showNote", id);
    },
    getColor(cat) {
      switch (cat) {
        case "Digital":
          return "#b85cce";
        case "Physical":
          return "#02b0d1";
        case "Logistics":
          return "#87969d";
        case "Opportunity":
          return "#8BC34A";
        case "Bottleneck":
          return "#F44336";
        default:
          return "grey";
      }
    },
  },
};
</script>
